module.exports = __webpack_public_path__ + "img/2x3_repeat.9b5fd5da.jpg";